import Component from '../app/component';

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {
      markers: []
    };
  }

  init() {
    if (window?.google?.maps) {
      this.mapSetup();
    } else {
      document.addEventListener('google.maps.init', () => this.mapSetup());
    }

    this.formSetup();
  }

  formSetup() {
    if (this.refs.form && this.refs.submit) {
      this.refs.submit.addEventListener('click', (e) => {
        e.preventDefault();
        const checkedRadio = this.refs.form.querySelector('input[name="type"]:checked');
        const address = this.refs.addressField.value;
        const type = checkedRadio ? checkedRadio.value : null;
        this.mapFilter(address, type);
      });
    }
  }

  mapSetup() {
    if (!window?.google?.maps) {
      return;
    }
    this.map = new window.google.maps.Map(
      this.refs.map,
      {
        center: {
          lat: window?.__map?.latitude ? parseFloat(window.__map.latitude) : 41.871941,
          lng: window?.__map?.longitude ? parseFloat(window.__map.longitude) : 12.567380
        },
        zoom: window?.__map?.zoom || 10,
        styles: [
          {
            'featureType': 'administrative',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#444444'
              }
            ]
          },
          {
            'featureType': 'administrative.country',
            'elementType': 'labels',
            'stylers': [
              {
                'visibility': 'simplified'
              }
            ]
          },
          {
            'featureType': 'administrative.province',
            'elementType': 'labels',
            'stylers': [
              {
                'visibility': 'simplified'
              }
            ]
          },
          {
            'featureType': 'administrative.locality',
            'elementType': 'labels',
            'stylers': [
              {
                'visibility': 'simplified'
              }
            ]
          },
          {
            'featureType': 'administrative.neighborhood',
            'elementType': 'labels',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers': [
              {
                'color': '#f2f2f2'
              }
            ]
          },
          {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'poi',
            'elementType': 'labels',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'road',
            'elementType': 'all',
            'stylers': [
              {
                'saturation': -100
              },
              {
                'lightness': 45
              }
            ]
          },
          {
            'featureType': 'road',
            'elementType': 'geometry.fill',
            'stylers': [
              {
                'color': '#ffffff'
              }
            ]
          },
          {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'simplified'
              }
            ]
          },
          {
            'featureType': 'road.arterial',
            'elementType': 'labels.icon',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': [
              {
                'color': '#46bcec'
              },
              {
                'visibility': 'on'
              }
            ]
          }
        ]
      }
    );

    if (window?.__markers?.length) {
      window.__markers.forEach((item, i) => {
        const marker = new window.google.maps.Marker({
          position: {
            lat: parseFloat(item.latitude),
            lng: parseFloat(item.longitude)
          },
          map: this.map,
          title: item.name,
          icon: {
            url: '/assets/img/marker.png',
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(18.5, 50.5),
            scaledSize: new window.google.maps.Size(37, 50.5),
            size: new window.google.maps.Size(74, 101)
          }
        });
        marker._type = item.type;
        marker.addListener('click', () => this.scrollToStoreCard(i));
        this.data.markers.push(marker);
      });
    }
  }

  mapFilter(address, type) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // filter by type
    this.data.markers.forEach((marker) => {
      if (marker._type.includes(type) || type === 'all') {
        marker.setVisible(true);
      } else {
        marker.setVisible(false);
      }
    });

    // calculare distance
    if (window.google.maps.Geocoder && address) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder
        .geocode({ address })
        .then((response) => {
          if (response?.results?.length) {
            const responsePosition = response.results[0].geometry.location;
            this.map.setCenter(responsePosition);
            this.map.setZoom(12);
            this.data.markers.forEach((marker) => {
              const distance = this.getDistance(responsePosition, marker.getPosition());
              if (distance > 40000) {
                marker.setVisible(false);
              }
            });
          }
        });
    }

    if (this.refs?.storesCards?.length) {
      this.refs.storesCards.forEach((el) => {
        if (el.classList.contains(`storelocator-store--${type}`) || type === 'all') {
          el.classList.remove('storelocator-store--hide');
        } else {
          el.classList.add('storelocator-store--hide');
        }
      });
    }
  }

  scrollToStoreCard(i) {
    const id = `storelocator-store-${i}`;
    const el = document.querySelector(`#${id}`);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
      const elCurrentSelected = this.el.querySelector('.storelocator-store--selected');
      if (elCurrentSelected) {
        elCurrentSelected.classList.remove('storelocator-store--selected');
      }
      el.classList.add('storelocator-store--selected');
    }
  }

  /* eslint-disable */
  getDistance(p1, p2) {
    const rad = function (x) {
      return x * Math.PI / 180;
    };
    const R = 6378137; // Earth’s mean radius in meter
    const dLat = rad(p2.lat() - p1.lat());
    const dLong = rad(p2.lng() - p1.lng());
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1.lat())) * Math.cos(rad(p2.lat())) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return d; // returns the distance in meter
  }
  /* eslint-enable */
}
